import PageMeta from "../../../components/common/PageMeta";
import PageBreadcrumb from "../../../components/common/PageBreadCrumb";
import WebhooksTable from "../../../components/apps/webhooks/WebhooksTable";
import { useNavigate } from "react-router";

export default function Webhooks() {
    const navigate = useNavigate();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/apps`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Webhooks"
                description="Webhooks"
            />
            <PageBreadcrumb
                pageTitle="Webhooks"
                showBackButton={true}
                onBack={handleGoBack}
            />
            <div className="grid grid-cols-12 gap-4 md:gap-6">

                <div className="col-span-12 space-y-6">
                    <WebhooksTable />
                </div>
            </div>
        </>
    );
}